const tabbedContentSections = document.querySelectorAll('.tabbed-content--container');
if (tabbedContentSections) {
  tabbedContentSections.forEach(section => {
    const sectionID = section.dataset.sectionId;
    const container = document.getElementById(`shopify-section-${sectionID}`);
    const tabPanels = container.querySelectorAll('.tab-panel');
  
    tabPanels.forEach(panel => {
      const targetID = panel.dataset.targetContent;
      const target = document.getElementById(targetID);
  
      // We need to grab the targets parent since some functionality is tied to the sections wrapping element (FAQ accordion for example) 
      const targetWrapper = target.parentElement; 
  
      if (targetWrapper) {
        panel.appendChild(targetWrapper);
      }
  
      // If the tab content is going to be empty, hide the tab
      if (targetWrapper.textContent.trim() === '') {
        const tabPanelLabelAttribute = panel.getAttribute('tab-panel-label');
        const tabToHide = document.querySelector(`label[for="${tabPanelLabelAttribute}"]`);
  
        if (tabToHide) {
          tabToHide.style.display = 'none';
        }
      }
    });
  });
}
